import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class ExitWarehouseRegister {
  // 出仓登记列表
  static getExitWarehouseRegisterList(options) {
    let url = '/zwy/api/storage/deliver/order/page?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 导入增值费用
  static postExitWarehouseUploadAddServiceExcel(data) {
    const url = `/zwy/api/storage/deliver/order/upload/add/service/fee`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 导入操作费用
  static postExitWarehouseUploadOperateFeeExcel(data) {
    const url = `/zwy/api/storage/deliver/order/upload/fee`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 出仓单详情
  static getExitWarehouseRegisterDetails(id) {
    const url = `/zwy/api/storage/deliver/order/get/${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑出仓登记备注
  static postModExitWarehouseRemarks(id, data) {
    const url = `/zwy/api/storage/deliver/order/update/remark/${id}`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 保存出仓登记
  static postSaveExitWarehouseRegister(id, data) {
    const url = `/zwy/api/storage/deliver/order/update/fee/${id}`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取出仓单增值服务费用导入模板 */
  static getExitWarehouseAddServiceTmp() {
    const url = `/zwy/api/storage/deliver/order/download/service/fee/template/file`
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default ExitWarehouseRegister